import { getDesktopMenus } from '@desktop/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {userStaticMenus,supplierStaticMenus,agencyPageStaticMenus,offlinesupplierStaticMenus} from '../../config'

const common = {
  state: {
    desktopMenus:[]
  },
  mutations: {
    SET_DESKTOP_MENUS: (state, data) => {
      let {activeMenus,msid} = data
      //let userType = getToken('userType') || ''

      //state.desktopMenus = userStaticMenus(msid).concat(activeMenus);
      state.desktopMenus = activeMenus;
    },
    other_login:(state, data)=> {
      let msid = getToken('msid')||'';
      let urlLogin = `/srmoem/api/user/srmOemLogin?msid=${msid}`;

    },
    OEM_next: (state, data) =>{
      let urlNew = `/srmoem/api/srm/signSecrecy?requirementId=37`
    },
  },
  actions: {
    GetDesktopMenus({ commit, rootGetters, state }) {
      return new Promise((resolve, reject) => {
        getDesktopMenus().then(res => {
          commit('SET_DESKTOP_MENUS', {activeMenus:res.data,msid:rootGetters.msid})
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default common



// WEBPACK FOOTER //
// ./src/modules/desktop/store/modules/common.js